import React, { useEffect, useState } from "react";
import { formatPrice } from "../lib/format";
import { useSearchParams, Link } from "react-router-dom";
import { api } from "../lib/api";
import { useCart } from "../contexts/CartContext";

export default function CheckoutSuccess() {
  const [params] = useSearchParams();
  const orderId = params.get("order");
  const [order, setOrder] = useState(null);
  const { clear } = useCart();

  useEffect(() => {
    if (!orderId) return;
    api.post(`/orders/${orderId}/confirm`).then(r => { setOrder(r.data); clear(); }).catch(()=>{});
    // eslint-disable-next-line
  }, [orderId]);

  return (
    <div className="max-w-2xl mx-auto px-6 py-24 text-center">
      <p className="font-serif-italic text-3xl text-berulia-rosedeep">Merci ✿</p>
      <h1 className="font-heading text-5xl mt-4">Votre commande est <span className="font-serif-italic">confirmée</span></h1>
      {order ? (
        <>
          <p className="overline mt-6">N° {order.order_number}</p>
          <p className="mt-6 text-berulia-inkmuted">Un email de confirmation vient de partir vers <strong>{order.customer_email}</strong>. Nous préparons votre commande avec soin.</p>
          <div className="mt-10 bg-white border border-berulia-border p-6 text-left">
            <p className="overline mb-3">Récapitulatif</p>
            <div className="space-y-2 text-sm">
              {order.items.map((it,i)=>(<div key={i} className="flex justify-between"><span>{it.name} ({it.size}) × {it.quantity}</span><span>{formatPrice((it.unit_price*it.quantity))}</span></div>))}
            </div>
            <div className="mt-4 pt-4 border-t border-berulia-border text-sm space-y-1">
              <div className="flex justify-between"><span>Livraison ({order.carrier.replace("_"," ")})</span><span>{order.shipping_fee===0?"Offerte":formatPrice(order.shipping_fee)}</span></div>
              <div className="flex justify-between font-heading text-xl"><span>Total</span><span>{formatPrice(order.total)}</span></div>
            </div>
          </div>
        </>
      ) : <p className="mt-6 text-berulia-inkmuted">Chargement…</p>}
      <Link to="/mon-compte" className="inline-block mt-10 overline link-underline" data-testid="goto-account">Suivre ma commande →</Link>
    </div>
  );
}
